import { useSelector } from 'react-redux';

import { selectActiveTaxonomies } from 'features/auth/auth.slice';

interface UseTaxonomyData {
    id: number;
    currencySymbol: string;
    style: string;
}

export const useTaxonomy = (): UseTaxonomyData => {
    const activeTaxonomies = useSelector(selectActiveTaxonomies);

    const defaults: UseTaxonomyData = {
        id: 0,
        currencySymbol: '$',
        style: '',
    };

    if (!activeTaxonomies) {
        return defaults;
    }

    return {
        id: Number(activeTaxonomies[0].id),
        currencySymbol: activeTaxonomies[0].currencySymbol || defaults.currencySymbol,
        style: activeTaxonomies[0].style || defaults.style,
    };
};
